import { Controller } from '@stimulus/core';

export default class ModalController extends Controller {
    public static targets = [];

    public toggleModalClass(event: CustomEvent) : void {
        event.detail.add.forEach(element => this.element.classList.add(element))
        event.detail.remove.forEach(element => this.element.classList.remove(element))
    }
}